export interface CurrencyConfig {
  symbol: string;
  price: string;
  code: string;
}

const currencies: Record<string, CurrencyConfig> = {
  GBP: { symbol: '£', price: '84', code: 'GBP' },
  EUR: { symbol: '€', price: '99', code: 'EUR' },
  USD: { symbol: '$', price: '109', code: 'USD' },
};

const euCountries = new Set([
  'AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE',
  'IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE',
]);

export function getCurrencyForCountry(countryCode: string): CurrencyConfig {
  if (countryCode === 'GB') return currencies.GBP;
  if (euCountries.has(countryCode)) return currencies.EUR;
  return currencies.USD;
}

export const defaultCurrency = currencies.GBP;
